import { BLUE_500, BLUE_GREY_100, LILAC_300, tokens } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getAnchoredActionWidgetStyles = (props, isSmallScreen, theme) => {
  var _props$noPadding = props.noPadding,
    noPadding = _props$noPadding === void 0 ? false : _props$noPadding,
    _props$backgroundColo = props.backgroundColor,
    backgroundColor = _props$backgroundColo === void 0 ? theme == 'white' ? BLUE_GREY_100 : LILAC_300 : _props$backgroundColo,
    contentAlignmentDirection = props.contentAlignmentDirection,
    withRowAlignedContent = props.withRowAlignedContent,
    isInsideGridColumn = props.isInsideGridColumn;
  var spacing = tokens.spacing;
  var borderRadius = tokens.borderRadius;
  return StyleSheet.create({
    gratification: {
      flexDirection: 'row',
      alignItems: 'center',
      paddingHorizontal: spacing.SPACING_20,
      paddingVertical: spacing.SPACING_8,
      backgroundColor: BLUE_500,
      borderTopLeftRadius: borderRadius.BORDER_RADIUS_16,
      borderTopRightRadius: borderRadius.BORDER_RADIUS_16
    },
    gratificationIcon: {
      marginRight: spacing.SPACING_4,
      flexShrink: 0
    },
    content: Object.assign(Object.assign(Object.assign({}, !!contentAlignmentDirection && {
      flexDirection: contentAlignmentDirection
    }), {
      backgroundColor
    }), !noPadding && Object.assign(Object.assign({}, isInsideGridColumn && {
      paddingHorizontal: spacing.SPACING_24
    }), {
      paddingVertical: !isSmallScreen ? spacing.SPACING_20 : spacing.SPACING_16
    })),
    checkbox: {
      marginBottom: !isSmallScreen ? spacing.SPACING_0 : spacing.SPACING_20
    },
    metaSpacer: Object.assign(Object.assign({
      alignSelf: 'center'
    }, contentAlignmentDirection ? {
      flex: 1
    } : {
      marginTop: spacing.SPACING_20
    }), !!contentAlignmentDirection && contentAlignmentDirection === 'row' && {
      marginLeft: spacing.SPACING_20
    }),
    actionCta: {
      marginTop: tokens.spacing.SPACING_4
    },
    gridColumnStyle: {
      justifyContent: withRowAlignedContent ? 'center' : 'flex-start',
      paddingRight: !isSmallScreen ? spacing.SPACING_24 : spacing.SPACING_0
    },
    gridStyle: {
      alignSelf: isInsideGridColumn ? 'flex-start' : 'flex-end',
      justifyContent: 'center'
    },
    gridStyleButton: {
      justifyContent: 'center'
    },
    priceDiscount: {
      display: 'flex',
      flexDirection: !isSmallScreen ? 'row' : 'column',
      justifyContent: 'space-between'
    },
    priceBreakUp: {
      flex: 1,
      justifyContent: 'space-between',
      flexDirection: 'row',
      marginBottom: spacing.SPACING_16
    },
    discountedPrice: {
      flex: 1,
      justifyContent: 'space-between',
      flexDirection: 'row',
      marginBottom: spacing.SPACING_20
    },
    rightTypoGraphyContainer: {
      flex: 1,
      flexDirection: 'row-reverse'
    },
    priceWithInfoTag: {
      flexDirection: 'column',
      alignItems: 'flex-end'
    },
    priceTypography: {
      marginBottom: tokens.spacing.SPACING_4
    }
  });
};